<webvis-ui-page-wrap>
   <section class="h-full flex flex-col items-center justify-center">
      <shared-ui-svg-icon
         [icon]="'images/common/dedfish.svg'"
         class="mb-4"
      ></shared-ui-svg-icon>
      <h3>{{ 'pages.not_found' | translate }}</h3>
      <p>{{ '404.page_does_not_exist' | translate }}</p>
      <button
         (click)="goBack()"
         class="w-1/2 md:w-1/3 lg:w-1/4"
         mat-flat-button
      >
         {{ (isAdmin() ? '404.call_danny' : '404.go_back') | translate }}
      </button>
   </section>
</webvis-ui-page-wrap>
